import React from 'react';
import { useAppleSignIn } from '../../hooks/useAppleSignIn';
import { Button } from './Button';

interface AppleSignInButtonProps {
  text?: 'signin' | 'signup' | 'continue';
  className?: string;
  disabled?: boolean;
}

export const AppleSignInButton: React.FC<AppleSignInButtonProps> = ({
  text = 'continue',
  className = '',
  disabled = false,
}) => {
  const { signInWithApple, isLoading, isAppleLoaded } = useAppleSignIn();

  const getButtonText = () => {
    switch (text) {
      case 'signin':
        return 'Sign in with Apple';
      case 'signup':
        return 'Sign up with Apple';
      case 'continue':
      default:
        return 'Continue with Apple';
    }
  };

  const handleClick = async () => {
    if (!disabled && !isLoading) {
      await signInWithApple();
    }
  };

  // Don't show if Apple Sign-In is not available (not loaded or not supported)
  if (!isAppleLoaded) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="outline"
      className={`w-full bg-black hover:bg-gray-900 text-white border-black hover:border-gray-900 ${className}`}
      onClick={handleClick}
      disabled={disabled || isLoading}
      isLoading={isLoading}
    >
      <svg 
        className="w-5 h-5 mr-2" 
        viewBox="0 0 24 24" 
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
      </svg>
      {getButtonText()}
    </Button>
  );
};
